import { isNull, isObject, isUndefined } from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ROLE_ADMIN } from '../utils/constants/roles.js';

function useUserHasRole(rolesToFind = []) {
  const user = useSelector((state) => state.auth.user);

  return useMemo(() => {
    if (!isObject(user) || isNull(user) || isUndefined(user)) {
      return false;
    }

    // Premeníme na pole, ak náhodou nie je
    const rolesArray = Array.isArray(rolesToFind) ? rolesToFind : [rolesToFind];

    return user.roles.some((role) => rolesArray.includes(role.name));
  }, [user, rolesToFind]);
}

export default useUserHasRole;
